export const AUDIT_EVENTS = {
  DOCUMENT: "DOCUMENT",
  MESSAGE: "MESSAGE",
  SNAPSHOT: "SNAPSHOT",
  RENEWAL: "RENEWAL",
};

export default AUDIT_EVENTS;
